<template>
  <div :class="`card-info ${isFull===true ? 'full' : ''}`">
    <div class="shadow-wrapper" @click="close"></div>
    <div class="content">
      <card>
        <header-item :card="card" :user="user" />
        <tabs :tabs="tabs" title="sd" :active="activeTab" v-model="activeTab" />
        <template v-for="(tab, key) in tabs">

          <keep-alive v-if="tab.keepAlive == true && activeTab === key" :key="key">
            <component
              :is="tab.component"
              :id="id"
            />
  
          </keep-alive>

          <component
            v-else-if="!tab.keepAlive && activeTab === key"
            :is="tab.component"
            :id="id"
            :key="key"
          />
      
        </template>
        <slot></slot>
      </card>
    </div>
  </div>
</template>
<script>
export default {
  props: ["card", "activeTab", "tabs", "id", "isFull", "user"],
  methods: {
    close() {
      let query = Object.assign({}, this.$route.query);
      if (query[this.card]) {
        delete query[this.card];
      } else {
        return false;
      }
      this.$router.replace({ query });
    },
  },
  components: {
    HeaderItem: () => import("./HeaderItem"),
  },
};
</script>